// src/components/aiInterviewUtils.js
import dayjs from "dayjs";
import {
  QIDS, LABELS, FIELD,
  getAnswer, getQuestionText, getSubId, getRegenCount,
  pickBaseQuestion,
} from "../schema/aiInterviewSchema";

export const QUESTION_LABELS = Object.fromEntries(
  QIDS.map((qid) => [qid, LABELS[qid]])
);

export const LABEL_ORDER = [
  LABELS.msws1, LABELS.msws2, LABELS.msws3,
  LABELS.amsq,
  LABELS.mfis_cog, LABELS.mfis_phy, LABELS.mfis_soc,
  LABELS.msnq_att, LABELS.msnq_mem, LABELS.msnq_other, LABELS.msnq_pb,
];

// records + question.json → 表示行（質問=records、元の質問=question.json）
export function parseRecords(records, baseQuestions = []) {
  const parsed = [];
  const dateSet = new Set();

  (records || []).forEach((entry) => {
    const raw = entry?.[FIELD.date];
    // ✅ 'YYYY-MM-DD HH:mm:ss' でも確実に取れるように先頭10文字を使用
    const date = (typeof raw === "string" && raw.length >= 10)
      ? raw.slice(0, 10) // "YYYY-MM-DD"
      : "";

    if (date) dateSet.add(date);

    QIDS.forEach((qid) => {
      const answer = getAnswer(entry, qid);
      if (typeof answer === "number") {
        const question = getQuestionText(entry, qid) ?? "";
        const subId = getSubId(entry, qid);
        const baseQ = pickBaseQuestion(qid, subId, baseQuestions) || "";

        parsed.push({
          date,                   // ← "YYYY-MM-DD" 固定
          category: qid,
          label: LABELS[qid],
          score: answer,
          question,
          baseQuestion: baseQ,
          regenerateCount: getRegenCount(entry, qid),
        });
      }
    });
  });

  // ✅ "YYYY-MM-DD" を文字列比較で降順（最新→過去）
  const dates = Array.from(dateSet).sort((a, b) => (a < b ? 1 : -1));

  return { rows: parsed, dates };
}

export function makeDummyShortRecordsIfNeeded(records) {
  return Array.isArray(records) ? records : [];
}